"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.loadSync = void 0;
const fs_1 = __importDefault(require("fs"));
const common_1 = require("./common");
const LoadOptions_1 = require("./LoadOptions");
const loadSync = (options = {}) => {
    const opt = Object.assign(Object.assign({}, LoadOptions_1.nodeDefaultLoadOptions), options);
    let dotenvStr;
    try {
        dotenvStr = fs_1.default.readFileSync(opt.path, "utf-8");
    }
    catch (e) {
        if (opt.failSilently) {
            return {};
        }
        else {
            throw e;
        }
    }
    return common_1._appendEnv(dotenvStr, process, options.validator);
};
exports.loadSync = loadSync;
const load = (options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const opt = Object.assign(Object.assign({}, LoadOptions_1.nodeDefaultLoadOptions), options);
    let dotenvStr;
    try {
        dotenvStr = yield fs_1.default.promises.readFile(opt.path, "utf-8");
    }
    catch (e) {
        if (!opt.failSilently) {
            throw e;
        }
    }
    return common_1._appendEnv(dotenvStr, process, options.validator);
});
exports.load = load;
exports.default = exports.load;
//# sourceMappingURL=node.js.map